const Fcontent1 = () => {
  return (
    <section
      id="content-1"
      className="content-1 wide-60 inner-page-hero content-section division"
    >
      <div className="container">
        <div className="row d-flex align-items-center">
          {/* TEXT BLOCK */}
          <div className="col-md-7 col-lg-6 order-last order-md-2">
            <div className="txt-block left-column wow fadeInRight">
              {/* Section ID */}
              <span className="section-id txt-upcase">Powerful Management</span>
              {/* Title */}
              <h2 className="h2-xs">
                {`Streamline your translation workflow in one place`}
              </h2>
              {/* List */}
              <ul className="simple-list">
                <li className="list-item">
                  <p className="p-lg">
                    Manage all your translation projects from a single, intuitive dashboard.
                  </p>
                </li>
                <li className="list-item">
                  <p className="p-lg">
                    Real-time collaboration tools for project managers and translators.
                  </p>
                </li>
                <li className="list-item">
                  <p className="p-lg">
                    Centralized file storage with version control and easy exports.
                  </p>
                </li>
              </ul>
            </div>
          </div>{" "}
          {/* END TEXT BLOCK */}
          {/* IMAGE BLOCK */}
          <div className="col-md-5 col-lg-6 order-first order-md-2">
            <div className="rel img-block right-column wow fadeInLeft">
              <img
                className="img-fluid"
                src="/images/img-07.png"
                alt="content-image"
              />
            </div>
          </div>
        </div>{" "}
        {/* End row */}
      </div>{" "}
      {/* End container */}
    </section>
  );
};

export default Fcontent1;
